import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import WelcomeScreen from './components/WelcomeScreen';
import OnboardingFlow from './components/OnboardingFlow';
import AssessmentComplete from './components/AssessmentComplete';

function App() {
  const [currentScreen, setCurrentScreen] = useState('welcome');
  const [userProgress, setUserProgress] = useState({
    currentDimension: 1,
    currentPosture: 0,
    completedPostures: [],
    recordings: {}
  });

  // Load progress from localStorage on mount
  useEffect(() => {
    const savedProgress = localStorage.getItem('7dimensions-progress');
    if (savedProgress) {
      setUserProgress(JSON.parse(savedProgress));
    }
  }, []);

  // Save progress to localStorage whenever it changes
  useEffect(() => {
    localStorage.setItem('7dimensions-progress', JSON.stringify(userProgress));
  }, [userProgress]);

  const handleStartAssessment = () => {
    setCurrentScreen('onboarding');
  };

  const handleCompleteAssessment = () => {
    setCurrentScreen('complete');
  };

  const handleRestartAssessment = () => {
    setUserProgress({
      currentDimension: 1,
      currentPosture: 0,
      completedPostures: [],
      recordings: {}
    });
    setCurrentScreen('welcome');
  };

  const updateProgress = (newProgress) => {
    setUserProgress(prev => ({ ...prev, ...newProgress }));
  };

  return (
    <div className="min-h-screen bg-dark-950 text-dark-50">
      <AnimatePresence mode="wait">
        {currentScreen === 'welcome' && (
          <motion.div
            key="welcome"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <WelcomeScreen onStart={handleStartAssessment} />
          </motion.div>
        )}
        
        {currentScreen === 'onboarding' && (
          <motion.div
            key="onboarding"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <OnboardingFlow
              progress={userProgress}
              onUpdateProgress={updateProgress}
              onComplete={handleCompleteAssessment}
            />
          </motion.div>
        )}
        
        {currentScreen === 'complete' && (
          <motion.div
            key="complete"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
            exit={{ opacity: 0 }}
            transition={{ duration: 0.5 }}
          >
            <AssessmentComplete
              progress={userProgress}
              onRestart={handleRestartAssessment}
            />
          </motion.div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
